<template>
  <div class="border">
    <div style="padding:1rem">
      <b-row style="margin:0.5rem 0 0.5rem 0;">
        <strong><p>ข้อมูลของวันที่</p></strong>
        <b-form-datepicker
          v-model="startDate"
          locale="th"
          class="mb-2"
          style="width:25%;margin:0 1rem 0 1rem;"
        ></b-form-datepicker>

        <strong><p>ถึง</p></strong>

        <b-form-datepicker
          v-model="endDate"
          locale="th"
          class="mb-2"
          style="width:25%;margin:0 1rem 0 1rem;"
        ></b-form-datepicker>
      </b-row>
      <b-row>
        <b-col cols="12">
          <vdoView
            :apiRoute="
              `/v1/analytics/courses/getStudentViewLectureStat?cId=${cId}&startDate=${startDate}&endDate=${endDate}`
            "
            :startDate="startDate"
            :endDate="endDate"
            :perPage="10"
          ></vdoView>
        </b-col>
        <!-- <b-col cols="5">
          <downloadMaterial :perPage="10"></downloadMaterial>
        </b-col> -->
      </b-row>
    </div>
  </div>
</template>

<script>
import vdoView from './CourseViewPanel';
// import downloadMaterial from './CourseMaterialDownloadPanel'
// import calender from '@/components/shared/DatePicker'
import moment from 'moment';
export default {
  data() {
    return {
      startDate: moment()
        .subtract(1, 'months')
        .format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      cId: this.$route.params.cId,
    };
  },
  components: {
    vdoView,
    // downloadMaterial,
    // calender,
  },
};
</script>
<style scoped></style>
